/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationProviderDto } from './ConversationProviderDto';
import {
    ConversationProviderDtoFromJSON,
    ConversationProviderDtoFromJSONTyped,
    ConversationProviderDtoToJSON,
    ConversationProviderDtoToJSONTyped,
} from './ConversationProviderDto';
import type { ConversationPatientDto } from './ConversationPatientDto';
import {
    ConversationPatientDtoFromJSON,
    ConversationPatientDtoFromJSONTyped,
    ConversationPatientDtoToJSON,
    ConversationPatientDtoToJSONTyped,
} from './ConversationPatientDto';

/**
 * 
 * @export
 * @interface ConversationDto
 */
export interface ConversationDto {
    /**
     * Conversation ID
     * @type {string}
     * @memberof ConversationDto
     */
    id: string;
    /**
     * Patient ID
     * @type {string}
     * @memberof ConversationDto
     */
    patientId: string;
    /**
     * Provider ID
     * @type {string}
     * @memberof ConversationDto
     */
    providerId: string;
    /**
     * Last message timestamp
     * @type {Date}
     * @memberof ConversationDto
     */
    lastMessageAt?: Date;
    /**
     * Last message preview
     * @type {string}
     * @memberof ConversationDto
     */
    lastMessagePreview?: string;
    /**
     * Unread count for patient
     * @type {number}
     * @memberof ConversationDto
     */
    unreadCountPatient: number;
    /**
     * Unread count for provider
     * @type {number}
     * @memberof ConversationDto
     */
    unreadCountProvider: number;
    /**
     * Patient info
     * @type {ConversationPatientDto}
     * @memberof ConversationDto
     */
    patient: ConversationPatientDto;
    /**
     * Provider info
     * @type {ConversationProviderDto}
     * @memberof ConversationDto
     */
    provider: ConversationProviderDto;
}

/**
 * Check if a given object implements the ConversationDto interface.
 */
export function instanceOfConversationDto(value: object): value is ConversationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('providerId' in value) || value['providerId'] === undefined) return false;
    if (!('unreadCountPatient' in value) || value['unreadCountPatient'] === undefined) return false;
    if (!('unreadCountProvider' in value) || value['unreadCountProvider'] === undefined) return false;
    if (!('patient' in value) || value['patient'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    return true;
}

export function ConversationDtoFromJSON(json: any): ConversationDto {
    return ConversationDtoFromJSONTyped(json, false);
}

export function ConversationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'providerId': json['providerId'],
        'lastMessageAt': json['lastMessageAt'] == null ? undefined : (new Date(json['lastMessageAt'])),
        'lastMessagePreview': json['lastMessagePreview'] == null ? undefined : json['lastMessagePreview'],
        'unreadCountPatient': json['unreadCountPatient'],
        'unreadCountProvider': json['unreadCountProvider'],
        'patient': ConversationPatientDtoFromJSON(json['patient']),
        'provider': ConversationProviderDtoFromJSON(json['provider']),
    };
}

export function ConversationDtoToJSON(json: any): ConversationDto {
    return ConversationDtoToJSONTyped(json, false);
}

export function ConversationDtoToJSONTyped(value?: ConversationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'providerId': value['providerId'],
        'lastMessageAt': value['lastMessageAt'] == null ? undefined : ((value['lastMessageAt']).toISOString()),
        'lastMessagePreview': value['lastMessagePreview'],
        'unreadCountPatient': value['unreadCountPatient'],
        'unreadCountProvider': value['unreadCountProvider'],
        'patient': ConversationPatientDtoToJSON(value['patient']),
        'provider': ConversationProviderDtoToJSON(value['provider']),
    };
}

